var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('button',{class:_vm.currentActiveTab,on:{"click":_vm.tabClicked}},[_c('i',{staticClass:"bx bx-book-content font-size-20 d-sm-none"}),_c('span',{staticClass:"d-none d-sm-block"},[_vm._v(_vm._s(_vm.tabTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }